import React from 'react';
import FramiSvgIcon from './FramiSvgIcon';

function InfoIcon(props) {
    return (
        <FramiSvgIcon {...props} viewBox="0 0 24 24">
            {/*<g id="SVGRepo_bgCarrier" stroke-width="0"/>*/}
            {/*<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>*/}
            <g id="SVGRepo_iconCarrier">
                <path
                    id="secondary"
                    d="M12,17a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v4A1,1,0,0,1,12,17ZM12,6.5A1.5,1.5,0,1,0,13.5,8,1.5,1.5,0,0,0,12,6.5Z"
                    fill="#2D3746"
                />
            </g>
        </FramiSvgIcon>
    );
}

export default InfoIcon;
